import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useToast } from '../../hooks';
import { userActions } from '../../store/user';
import { apiService } from '../../services/api';
import PlusLogo from '../../assets/plusLogo.svg';
import { Button } from '../../components/Button';
import HttpsIcon from '@mui/icons-material/Https';
import { BoxForm } from '../../components/BoxForm';
import { bindActionCreators } from '@reduxjs/toolkit';
import { Input } from '../../components/Inputs/Input';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { formRules } from '../../components/RegisterForm/FormRules';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { usersService } from '../../services/users.service';

export interface IFormInput {
  email: string;
  password: string;
}

export const LoginPage = () => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();
  const { login } = bindActionCreators(userActions, dispatch);

  const userFormDefaultValues: IFormInput = {
    email: '',
    password: '',
  };

  const methods = useForm<IFormInput>({
    defaultValues: userFormDefaultValues,
  });

  const { handleSubmit, reset } = methods;

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    setIsLoading(true);
    await apiService
      .login(data.email, data.password)
      .then(async () => {
        const user = await usersService.me();
        toast.success('Login realizado com sucesso!');
        reset();
        login(user);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex justify-center items-center w-full h-screen">
      <FormProvider {...methods}>
        <BoxForm
          className="shadow-xl p-8 rounded-[2.81rem] overflow-hidden max-w-xl w-4/5"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <img
            className="flex self-center h-[16rem] w-[16rem]"
            src={PlusLogo}
            alt="logo"
          />
          <Input
            label="E-mail"
            type="email"
            name="email"
            placeholder="exemplo@gmail.com"
            rules={formRules.emailRequired}
            startAdornment={
              <InputAdornment position="start">
                <AccountCircle style={{ color: '#122B87' }} />
              </InputAdornment>
            }
          />
          <Input
            label="Senha"
            type="password"
            name="password"
            placeholder="******"
            rules={formRules.passwordRequired}
            startAdornment={
              <InputAdornment position="start">
                {<HttpsIcon style={{ color: '#122B87' }} />}
              </InputAdornment>
            }
          />
          <span className="text-center font-roboto font-bold text-gray-900">
            <Link
              className="text-blue-primary no-underline"
              to="reset-password"
            >
              Esqueci minha senha
            </Link>
          </span>
          <Button
            type="submit"
            style={{
              color: '#122B87',
              fontWeight: '800',
              textTransform: 'none',
              borderRadius: '25px',
              padding: '.3rem',
            }}
            isLoading={isLoading}
          >
            ENTRAR
          </Button>
        </BoxForm>
      </FormProvider>
    </div>
  );
};
